<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Banka Hesabı</label>
            <v-select-list v-model="account" :disabled="(accounts || []).length == 0" placeholder="Banka Hesabı" label="Combine" :options="accounts"/>
        </div>
         <div class="col-12">
            <label class="from-label">Ödeme Tarihi</label>
                <v-date-picker v-model="date" placeholder="Ödeme Tarihi"></v-date-picker>
        </div>
    </div>
</template>

<script>
import BankApi from '@/api/bank'

export default{
    props:{
        value:Object
    },
    data(){
        return {
            accounts:[]
        }
    },
    mounted(){
        this.getAccounts()
    },
    methods:{
        getAccounts(){
            BankApi.CompanyBankAccount.List().then(res => {
                this.accounts = res.data.Data?.map(b=>({
                    ...b,
                    Combine: [b.Name,['(',b.Bank.BankName,' - ',b.AccountNumber,')'].join('')].join(' - ')
                }))
            })
        }
    },
    computed:{
        date:{
            get:function(){
                return this.value.Date;
            },
            set:function(value){
                return this.value.Date = value;
            }
        },
        account:{
            get:function(){
                return this.accounts.find(b=>b.Id==this.value.CompanyBankAccountId)
            },
            set:function(value){
                this.value.CompanyBankAccountId = value?.Id || null
            }
        },
    }
}
</script>